import script from "./CabeceraFormaDinamica.vue?vue&type=script&setup=true&lang=js"
export * from "./CabeceraFormaDinamica.vue?vue&type=script&setup=true&lang=js"

import "./CabeceraFormaDinamica.vue?vue&type=style&index=0&id=c2e03fc8&scoped=true&lang=css"

import exportComponent from "/var/www/html/manual/expositores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2e03fc8"]])

export default __exports__